import { faCheck, faEdit, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Formik } from 'formik';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import LoadingOverlay from '../../LoadingOverlay';
import { useStores } from '../../stores/useStores';

function Passcode(props) {
  const { authenticationStore } = useStores();
  const [editing, setEditing] = useState(false);

  const customOptions = props?.customOptions;
  const customFormOptions = customOptions?.form;

  return editing ? (
    <Formik
      initialValues={{
        passcode: props.trappingRun.passcode
      }}
      validate={(values, props) => {
        const errors = {};

        if (!values.passcode) errors.passcode = 'Required';

        return errors;
      }}
      onSubmit={(values, actions) => {
        fetch(
          `${process.env.REACT_APP_TRAPLOG_API_URL}api/trapping-runs/${props.trappingRun.id}`,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              Authorization: `Bearer ${authenticationStore.bearerToken}`,
              SeasonalDatabase: authenticationStore.selectedDatabase
            },
            body: JSON.stringify({
              passcode: values.passcode
            })
          }
        )
          .then((res) => {
            if (res.ok) return res.json();
            else if (res.status === 401)
              authenticationStore.refreshBearerToken();
            else throw Error(res.statusText);
          })
          .then((data) => {
            const newTrappingRun = { ...data };
            newTrappingRun.property_group = props.trappingRun.property_group;
            props.update(newTrappingRun);
            setEditing(false);
            actions.setSubmitting(false);
          })
          .catch((err) => {
            if (process.env.NODE_ENV === 'development') console.error(err);
            actions.setSubmitting(false);
          });
      }}
    >
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        errors,
        setFieldValue,
        isSubmitting,
        setFieldTouched
      }) => (
        <Card>
          <Card.Header className='d-flex justify-content-between align-items-center'>
            Passcode
            <div>
              <Button
                variant='link'
                className='text-success'
                type='button'
                onClick={handleSubmit}
              >
                <FontAwesomeIcon icon={faCheck} />
              </Button>
              <Button
                variant='link'
                className='text-danger'
                type='button'
                onClick={() => setEditing(false)}
              >
                <FontAwesomeIcon icon={faTimes} />
              </Button>
            </div>
          </Card.Header>
          <Card.Body>
            <Form noValidate onSubmit={handleSubmit}>
              <Form.Group controlId='passcode'>
                <Form.Control
                  type='text'
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.passcode}
                  placeholder='Passcode'
                  isInvalid={errors.passcode}
                />
                <Form.Control.Feedback type='invalid'>
                  {errors.passcode}
                </Form.Control.Feedback>
              </Form.Group>
            </Form>
            {isSubmitting ? <LoadingOverlay /> : null}
          </Card.Body>
        </Card>
      )}
    </Formik>
  ) : (
    <Card>
      <Card.Header className='d-flex justify-content-between align-items-center'>
        Passcode
        {!customOptions || customFormOptions?.editable ? ( // Display by default (no custom options).
          <Button variant='link' type='button' onClick={() => setEditing(true)}>
            <FontAwesomeIcon icon={faEdit} />
          </Button>
        ): null}
      </Card.Header>
      <Card.Body>{props.trappingRun.passcode}</Card.Body>
    </Card>
  );
}

Passcode.propTypes = {
  trappingRun: PropTypes.object.isRequired,
  update: PropTypes.func.isRequired
};

export default observer(Passcode);
